export default{"Login Successful":"\u767B\u9646\u6210\u529F","Check Password":"\u68C0\u67E5\u5BC6\u7801","Unknown Error":"\u672A\u77E5\u9519\u8BEF"};
